jQuery(document).ready(function($) {
	var continueButton = document.getElementById('continue-button');
	const createSpinner = () => {
		let spinner = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
		let circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
		spinner.setAttribute('viewBox', '0 0 80 80');
		spinner.setAttribute('width', '60px');
		spinner.setAttribute('height', '60px');

		circle.setAttribute('fill', 'none');
		circle.setAttribute('stroke-linecap', 'round');
		circle.setAttribute('stroke-dasharray', 165);
		circle.setAttribute('stroke-width', '10%');
		circle.setAttribute('stroke', '#3dc795');
		circle.setAttribute('cx', 40);
		circle.setAttribute('cy', 40);
		circle.setAttribute('r', 36);

		spinner.appendChild(circle);

		return spinner;
	}
	const processLogin = e => {
		e.preventDefault();

		const form = e.target.closest('form');
		var errorDiv = document.getElementById('errorMessage');
		var successDiv = document.getElementById('successMessage');
		const data = {
			'action'        : 'whisk_process_studio_login',
			'api_key'       : form.elements.studio_api_key.value,
			'integration_id': form.elements.studio_integration_id.value,
		};

		errorDiv.style.display = 'none';
		successDiv.style.display = 'none';

		// check for empty fields
		if ( ! form.elements.studio_api_key.value || ! form.elements.studio_integration_id.value ) {
			errorDiv.textContent = window.whisk_ob.empty_error;
			errorDiv.style.display = 'block';

			return;
		}

		// hide form, show spinner
		const spinner = createSpinner();
		var formRow = form.querySelector('.form-row');
		formRow.after(spinner);
		formRow.style.display = 'none';

		continueButton.classList.add('muted');
		continueButton.removeEventListener("click", processLogin);
		continueButton.href = 'javascript:void(0);';

		// send ajax
		$.post( window.whisk_ob.ajaxurl, data, function(response) {
			continueButton.disabled = false;
			continueButton.classList.remove('muted');
			//formRow.querySelector('svg').remove();

			if ( response.success ) {
				continueButton.href = document.getElementById('skip-button').href;
				successDiv.textContent = response.data.message;
				successDiv.style.display = 'block';
				document.getElementById('skip-button').remove();
				form.submit();
			} else {
				errorDiv.textContent = response.data.message;
				errorDiv.style.display = 'block';
				formRow.style.display = 'block';
			}
		});

	};

	if (continueButton) {
		continueButton.addEventListener("click", processLogin);
	}

	// change recipe url on urls_setup page
	const urlsSelect = document.getElementById('urlsBase');
	const nativeSelect = document.getElementById('nativeType');
	const semanticSelect = document.getElementById('semanticType');
	const urlPartsMapping = {
		meal_type: 'dinner',
		avoidance: 'gluten',
		cooking_technique: 'baking',
		cuisine: 'italian',
		diet: 'ketogenic',
		ingredient: 'avocado',
		nutrition: 'healthy',
	};
	const changeExample = e => {
		const value = e.target.value;

		if (semanticSelect.checked) {
			document.getElementById('whisk-recipe-url').textContent = '/' + urlPartsMapping[value] + '/your-awesome-recipe';
		}
	}
	const changeExampleNative = (e) => {
		const value = e.target.value;
		const example = document.getElementById('whisk-recipe-url');
		const native = example.dataset.structure.replaceAll('%', '');
		const urlsSelectValue = urlPartsMapping[urlsSelect.value];

		example.textContent = value === 'semantic' ? `/${urlsSelectValue}/your-awesome-recipe` : native;
	}

	if(urlsSelect && nativeSelect && semanticSelect) {
		urlsSelect.addEventListener('change', changeExample);
		nativeSelect.addEventListener('change', changeExampleNative);
		semanticSelect.addEventListener('change', changeExampleNative);
	}
});

